"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = minTranslate;
function minTranslate() {
  return -this.snapGrid[0];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJtaW5UcmFuc2xhdGUiLCJzbmFwR3JpZCJdLCJzb3VyY2VzIjpbIm1pblRyYW5zbGF0ZS5qcyJdLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBtaW5UcmFuc2xhdGUoKSB7XG4gIHJldHVybiAtdGhpcy5zbmFwR3JpZFswXTtcbn0iXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFlLFNBQVNBLFlBQVlBLENBQUEsRUFBRztFQUNyQyxPQUFPLENBQUMsSUFBSSxDQUFDQyxRQUFRLENBQUMsQ0FBQyxDQUFDO0FBQzFCIn0=